module.exports = __webpack_public_path__ + "img/牛蒡子.b6598fc0.jpg";